<script>

import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Service from '../../../services/operative-plan';
import config from '../../../common/genericPanelConf';
import ResponsiveButton from '../../generic/ResponsiveButton.vue';

import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';

export default{
    props: ['item'],
    components: {
        Dialog,
        ResponsiveButton,
        DataTable, Column
    },
    created(){
        this.aggregatedConfiguration = {...config.getConfiguration('DailyPlanManagement')};
        this.aggregatedConfiguration.customActions = [
            {
                name: 'addOperationAggregateButton',
                visible: false,
                cssClass: 'p-button-rounded p-button-success mr-2',
                icon: 'pi pi-arrow-up',
                data: {},
                fields: [],
                action: function(data, caller){
                    console.log(data)
                }
            }
        ];

        this.toAggregateConfiguration = {...config.getConfiguration('DailyPlanManagement')};
        this.toAggregateConfiguration.customActions = [
            {
                name: 'removeOperationAggregateButton',
                visible: false,
                cssClass: 'p-button-rounded p-button-success mr-2',
                icon: 'pi pi-arrow-down',
                data: {},
                fields: [],
                action: function(data, caller){
                    console.log(data)
                }
            }
        ];
        
    },
    mounted(){
        
    },
    data(){
        return{
            visible: false,
            toAggregateData: [],
            aggregatedData: [],
            aggregatedConfiguration: {},
            toAggregateConfiguration: {}
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        }
    },
    methods: {
        show(){
            this.visible = true;
            this.loadData();
        },
        loadData(){
            this.aggregatedData = [];
            this.toAggregateData = [];
            Service.getFiscalNotificationAggregationAggregable(this.item.idScheduledOperation, response => {
                if(response.success){
                    this.toAggregateData = response.data;
                }
            })
            Service.getFiscalNotificationAggregation(this.item.idScheduledOperation, response => {
                if(response.success){
                    this.aggregatedData = response.data;
                }
            })
        },
        createAggregation(data){
            let body = {
                idMainScheduledOperation: this.item.idScheduledOperation,
                idScheduledOperationToAggregate: data.idScheduledOperation
            };

            Service.addFiscalNotificationAggregation(body, ({success, message}) => {
                if(success){
                    this.visible = false;
                    this.$router.push({name: 'last-fiscal-notification', query: {idScheduledOperation: this.item.idScheduledOperation}})
                }else{
                    this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        removeAggregation(data){
            Service.removeFiscalNotificationAggregation(data.idScheduledOperation, ({success, message}) => {
                if(success){
                    this.visible = false;
                    this.$router.push({name: 'last-fiscal-notification', query: {idScheduledOperation: this.item.idScheduledOperation}})
                }else{
                    this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        }
    }
}

</script>

<template>
    <main>
        <Dialog :header="$t('dailyPlanManagement.aggregations')" v-model:visible="visible" :style="{width: '85vw'}" :modal="true">
            
            <h4>{{$t('dailyPlanManagement.operationsToAggregate')}}</h4>
            <DataTable responsiveLayout="scroll" :scrollable="true" :scrollHeight="'flex'"  class="p-datatable-sm my-2" :reorderableColumns="true" :value="toAggregateData"  dataKey="id" showGridlines stripedRows >

                <Column :exportable="false">
                    <template #body="slotProps">
                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-arrow-down" class="p-button-sm m-1" @click="createAggregation(slotProps.data)"/>
                    </template>
                </Column>

                <Column :hidden="col.gridHide" style="width: 240px" v-for="col of toAggregateConfiguration.columns" :field="col.name" :header="$t(col.label)" :key="col.name" sortable></Column>

                <template #empty>
                    {{$t('noRecordsFound')}}
                </template>
            </DataTable>

            <h4>{{$t('dailyPlanManagement.operationsAggregated')}}</h4>
            <DataTable responsiveLayout="scroll" :scrollable="true" :scrollHeight="'flex'"  class="p-datatable-sm my-2" :reorderableColumns="true" :value="aggregatedData"  dataKey="id" showGridlines stripedRows >
                <Column :exportable="false">
                    <template #body="slotProps">
                        <ResponsiveButton :label="$t('btn.remove')" icon="pi pi-arrow-up" class="p-button-sm m-1" @click="removeAggregation(slotProps.data)" :disabled="slotProps.data.idScheduledOperation == item.idScheduledOperation"/>
                    </template>
                </Column>
                
                <Column :hidden="col.gridHide" style="width: 240px" v-for="col of aggregatedConfiguration.columns" :field="col.name" :header="$t(col.label)" :key="col.name" sortable></Column>

                <template #empty>
                    {{$t('noRecordsFound')}}
                </template>
            </DataTable>

            <template #footer>
                <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-sm m-1" @click="visible = false"/>
            </template>

        </Dialog>
    </main>
</template>